import React from "react";

import "./RecognitionBanner.css";

import Banner from "../../assets/images/banner.svg";

export default function RecognitionBanner() {
  return (
    <div className="recognition-banner-outer-wrapper">
      <div className="content-wrapper">
        <div className="header">
          <h1>
            <span className="blue-colored">Recognize</span> and Appreciate your
            team!
          </h1>
        </div>

        <div className="points">
          Shout out your teammates and show them how much they matter to you.
        </div>
      </div>
      <div className="image-wrapper">
        <img src={Banner} alt="banner" />
      </div>
    </div>
  );
}
